import { render } from "./PersonalDetails.vue?vue&type=template&id=8a5916b2&scoped=true&lang=pug"
import script from "./PersonalDetails.vue?vue&type=script&lang=ts"
export * from "./PersonalDetails.vue?vue&type=script&lang=ts"

import "./PersonalDetails.vue?vue&type=style&index=0&id=8a5916b2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8a5916b2"

export default script